<div>
	<canvas baseChart [data]="stages.data" [labels]="stages.labels" [colors]="chartColors" chartType="pie" [options]="chartOptions" *ngIf="isReady && !!portfolio.theses"></canvas>
	<p *ngIf="!portfolio.theses">
		<i>{{ 'thesisProduct.noTheses' | translate }}</i>
	</p>
</div>
